<template>
  <div id="app" class="fl-app">
    <component
      v-if="isShowLayout"
      :is="layout"
    >
      <template #router>
        <router-view />
      </template>
    </component>
    <ui-portal-target name="modals" />
    <fl-global-modals />
    <fl-layout-loading />
  </div>
</template>

<script>
import FlCabinetLayout from "@/layouts/FlCabinetLayout.vue";
import FlEmptyLayout from "@/layouts/FlEmptyLayout.vue";
import FlGlobalModals from "@/components/FlGlobalModals.vue";
import FlLayoutLoading from "@/layouts/FlLayoutLoading.vue";
import UiPortalTarget from "@iflat-ui/components/portal/UiPortalTarget.vue"

import {EMPTY_LAYOUT, CABINET_LAYOUT} from "@/layouts/layoutConst";
import {ApiFactory} from "@/lib/apiConfig";

import mapIcon from "@/lib/mapIcon";
import {initResize} from "@iflat/iflat-ui/src/stores/window";
import {useLayoutStore} from "@/store/layout";
import {useUserStore} from "@/modules/User/store/user";

export default {
  name: 'App',
  components: {FlGlobalModals, UiPortalTarget, FlLayoutLoading},
  provide: {
    mapIcon,
    ApiFactory
  },
  data() {
    return {
      layoutStore: useLayoutStore(),
      userStore: useUserStore(),
    }
  },
  computed: {
    layout () {
      switch (this.$route.meta?.layout) {
        case CABINET_LAYOUT:
          return FlCabinetLayout
        case EMPTY_LAYOUT:
          return FlEmptyLayout
        default:
          return null
      }
    },
    isShowLayout () {
      return Boolean(!this.layoutStore.needHideLayout && this.layout)
    }
  },
  created() {
    initResize()
  },
}
</script>

<style lang="scss" scoped>
.fl-app {
  @include grid;
  grid-template-rows: 100fr;
  grid-auto-rows: 0;

  &.aside-left-open {
    .fl-style-layout__sidebar {
      @include transition-list([transform, opacity]);
      visibility: visible;
      transform: translateX(0);
      opacity: 1;
    }
  }
}
</style>
